module.exports = __webpack_public_path__ + "static/media/Indonesia_Hallyu_Book_Club.5fb36b6f.png";